var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Controller, } from 'react-hook-form';
import { Dropdown, MenuItem, FormController, FormLabel, Button, TextField, Typography, } from '@one-thd/sui-atomic-components';
import { getHyphenatedPhoneNumber } from '../../../utils/general';
import { PHONE_PLACEHOLDER } from '../../../constants/placeholders';
import { MAX_ALTERNATE_PHONES } from '../../../constants/general';
import { getTextFieldStatus } from '../../../utils/form';
export var AlternatePhones = function (props) {
    var register = props.register, errors = props.formState.errors, setValue = props.setValue, control = props.control, fields = props.fields;
    var handleOnChangePhone = function (name) {
        return function (event) {
            setValue(name, getHyphenatedPhoneNumber(event.currentTarget.value || ''));
        };
    };
    var addAlternatePhone = function () {
        var newAlternatePhone = {
            number: '',
            type: 'UNKNOWN',
            primaryFlag: 'N',
            secondaryFlag: 'N',
            preferenceType: 'NEW',
        };
        fields.append(newAlternatePhone);
    };
    var PhoneTypes = {
        MOBILE: 'MOBILE',
        WORK: 'WORK',
        UNKNOWN: 'UNKNOWN',
        HOME: 'HOME',
    };
    return (React.createElement("div", { className: "sui-grid sui-col-span-6 sui-gap-y-5 lg:sui-gap-y-8" },
        fields.fields.map(function (field, index, arr) {
            var _a, _b, _c, _d, _e;
            return (React.createElement("div", { key: field.id, className: "sui-grid sui-gap-x-3 sui-grid-cols-1 lg:sui-grid-cols-6 sui-gap-y-5 lg:sui-gap-y-8 sui-relative lg:sui-static" },
                React.createElement("div", { className: "lg:sui-col-span-3" },
                    React.createElement(TextField, { fullWidth: true, label: "Alternate Phone ".concat(index + 1), id: "phone", placeholder: PHONE_PLACEHOLDER, status: getTextFieldStatus((_b = (_a = errors.alternatePhones) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.number), statusMessage: (_e = (_d = (_c = errors.alternatePhones) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.number) === null || _e === void 0 ? void 0 : _e.message, InputProps: __assign(__assign({}, register("alternatePhones.".concat(index, ".number"), {
                            onChange: handleOnChangePhone("alternatePhones.".concat(index, ".number")),
                        })), { inputProps: { 'data-qm-mask': '' } }) })),
                React.createElement("div", { className: "lg:sui-col-span-2" },
                    React.createElement(Controller, { control: control, name: "alternatePhones.".concat(index, ".type"), render: function (_a) {
                            var controllerField = _a.field;
                            var ref = controllerField.ref, rest = __rest(controllerField, ["ref"]);
                            return (React.createElement("div", { className: "sui-relative", style: {
                                    zIndex: "".concat(arr.length - index),
                                } },
                                React.createElement(FormController, { fullWidth: true },
                                    React.createElement(FormLabel, null, "Phone Type"),
                                    React.createElement(Dropdown, __assign({ "data-testid": "phoneType".concat(index) }, rest, { placeholder: "Choose" }),
                                        React.createElement(MenuItem, { value: PhoneTypes.HOME },
                                            React.createElement("span", { "data-testid": "homePhoneType".concat(index) }, "Home")),
                                        React.createElement(MenuItem, { value: PhoneTypes.MOBILE },
                                            React.createElement("span", { "data-testid": "mobilePhoneType".concat(index) }, "Mobile")),
                                        React.createElement(MenuItem, { value: PhoneTypes.WORK },
                                            React.createElement("span", { "data-testid": "workPhoneType".concat(index) }, "Work"))))));
                        } })),
                React.createElement("div", { className: "sui-absolute lg:sui-static sui-top-0 sui-right-0 sui-m-auto lg:sui-mt-9" },
                    React.createElement(Button, { className: "hover:sui-fill-brand", onClick: function () {
                            fields.remove(index);
                        }, "data-testid": "removeAlternatePhone".concat(index, "Btn") },
                        React.createElement(Typography, { decoration: "underline" }, "Remove")))));
        }),
        fields.fields.length < MAX_ALTERNATE_PHONES && (React.createElement("div", { className: "sui-my-2" },
            React.createElement(Button, { className: "hover:sui-fill-brand", onClick: addAlternatePhone },
                React.createElement(Typography, { decoration: "underline" }, "Add Another Phone"))))));
};
